import { motion } from 'framer-motion';

export type Dish = {
  price: string;
  heading: string;
  description: string;
  imgSrc: string;
};

export const ChangeCards = ({ dishes }: { dishes: Dish[] }) => {
  return (
    <div className="mx-auto w-full max-w-7xl px-4">
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 w-full max-w-6xl mx-auto">
        {dishes.map((dish, index) => (
          <Card
            key={index}
            price={dish.price}
            heading={dish.heading}
            description={dish.description}
            imgSrc={dish.imgSrc}
          />
        ))}
      </div>
    </div>
  );
};

const Card = ({
  price,
  heading,
  description,
  imgSrc,
}: {
  price: string;
  heading: string;
  description: string;
  imgSrc: string;
}) => {
  return (
    <motion.div
      transition={{
        staggerChildren: 0.035,
      }}
      whileHover="hover"
      className="w-full h-[400px] bg-slate-300 overflow-hidden cursor-pointer group relative flex flex-col"
    >
      {/* Bildbereich */}
      <div className="relative h-[60%] w-full overflow-hidden">
        <div
          className="absolute inset-0 saturate-100 md:saturate-[.70] md:group-hover:saturate-[1.00] group-hover:scale-110 transition-all duration-500"
          style={{
            backgroundImage: `url(${imgSrc})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        {/* Preis oben rechts */}
        <div className="absolute top-2 right-2 bg-black/40 text-white px-2 py-1 rounded">
          <h4 className="text-2xl flex items-center">
            €{' '}
            {price.split('').map((l, i) => (
              <ShiftLetter letter={l} key={i} />
            ))}
          </h4>
        </div>
      </div>

      {/* Textbereich */}
      <div className="flex-grow bg-neutral-900 text-white p-4 flex flex-col justify-center">
        <h4 className="text-xl sm:text-3xl">{heading}</h4>
        <div className="divider my-2 !px-0 before:bg-[#FAED04] after:bg-[#FAED04]" />
        <p className="text-sm sm:text-base">{description}</p>
      </div>
    </motion.div>
  );
};

const ShiftLetter = ({ letter }: { letter: string }) => {
  return (
    <div className="inline-block overflow-hidden h-[36px] font-semibold text-3xl">
      <motion.span
        className="flex flex-col min-w-[4px]"
        style={{
          y: '0%',
        }}
        variants={{
          hover: {
            y: '-50%',
          },
        }}
        transition={{
          duration: 0.5,
        }}
      >
        <span>{letter}</span>
        <span>{letter}</span>
      </motion.span>
    </div>
  );
};
